import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import RoleFieldNumber from '../components/RoleFieldNumber';
import RoleFieldListItem from '../components/RoleFieldListItem';
import { updateRoleProperties } from '../actions';

const RoleActiveTokensListItem = ({
  code,
  category,
  maxActive,
  isEditing,
  canEdit,
  updateMaxActiveTokens,
}) => (
  <List.Item className="aridhia-role-active-tokens-list-item">
    <RoleFieldListItem
      code={code}
      category={category}
      value={maxActive}
      type="max.tokens"
      isEditing={isEditing}
      canEdit={canEdit}
    />
    {canEdit && isEditing && (
    <RoleFieldNumber
      text={maxActive}
      type="max.tokens"
      minValue={0}
      maxValue={100}
      onChange={(value) => updateMaxActiveTokens(code, category, { max_active_tokens: value })}
    />
    )}
  </List.Item>
);

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  const isEditing = item ? item.isEditing : false;

  return (
    {
      canEdit: update && !item.system,
      isEditing,
      maxActive: item ? item.max_active_tokens : 0,
    }
  );
};

const mapDispatchToProps = {
  updateMaxActiveTokens: updateRoleProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleActiveTokensListItem);
